import { Component, Inject, NgZone, ChangeDetectorRef, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';
import { OvsComponent } from '../core/ovs.core';
import { Geocoder, GeocoderResult, GeocoderStatus, CoordinateType, Geometry } from './ovs.geocoding';

@Component({
    selector: 'ovs-map',
    templateUrl: './ovs-map.component.html',
    styleUrls: ['./ovs-map.component.scss']
})
export class OvsMapComponent extends OvsComponent
{
    @Input() public geometry: Geometry | null; 
    @Input() public radius: number; 

    @ViewChild('mapElement') private mapElement: ElementRef;
    private _map: google.maps.Map;
    private _marker: google.maps.Marker;

    constructor() 
    {
        super();
        //console.log("Created OvsMapComponent");
        this.listenForChange(() => this.geometry, (o, n) => this.onInputChanged());
        this.listenForChange(() => this.radius, (o, n) => this.onInputChanged());
    }

    protected initialize(): void
    {

    }

    private onInputChanged(): void
    {
        //console.log("Entering onInputChanged");
        if (!this._map)
            this._map = new google.maps.Map(this.mapElement.nativeElement.children[0]);

        //console.log("_map set to " + this._map);

        if (this._marker != null)
        {
            this._marker.setMap(null);
            this._marker = <any>null;
        }

        if (this.geometry != null)
        {
            if (this.geometry.Bounds)
            {
                let bounds: google.maps.LatLngBoundsLiteral = { east: this.geometry.Bounds.East, north: this.geometry.Bounds.North, west: this.geometry.Bounds.West, south: this.geometry.Bounds.South };
                this._map.fitBounds(bounds);
                //console.log("Geometry bounds set");
            }

            if (this.geometry.Coordinates)
            {
                let location: google.maps.LatLngLiteral = { lat: this.geometry.Coordinates.Latitude, lng: this.geometry.Coordinates.Longitude };
                this._map.setCenter(location);
                //console.log("Map centered");

                this._marker = new google.maps.Marker({ position: location, map: this._map });

                if (!this.geometry.Bounds)
                {
                    let circle: google.maps.Circle = new google.maps.Circle({ center: new google.maps.LatLng(location.lat, location.lng), radius: (this.radius ? this.radius : 100) });
                    let bounds: google.maps.LatLngBounds = circle.getBounds();
                    this._map.fitBounds(bounds);
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/geo/ovs-map.component.ts